<template>
    <div v-show="visible">
        <el-dialog title="新增流程步骤" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-form-item prop="orderNum" label="步骤编号">
                         <el-input v-model="form.orderNum" maxlength="5" type="number" style="width:220px;"></el-input>
                    </el-form-item>

                    <el-form-item prop="name" label="步骤名称">
                         <el-input v-model="form.name" maxlength="50" style="width:220px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="checkerType" label="审批人依据类型">
                       <el-select v-model="form.checkerType" clearable placeholder="请选择" style="width:220px;">
                            <el-option
                                v-for="item in checkerTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
 
                    <el-form-item prop="checkerValue" label="审核人依据值" v-if="this.form.checkerType == 1" >
                        <el-input placeholder="请选择人名" :readonly="true" v-model="form.checkerValueLabel" class="input-with-select" style="width:220px;">
                            <el-button slot="append" icon="el-icon-search" @click="findUser()"></el-button>
                        </el-input>
                    </el-form-item>  

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                transferVisible:false,
                form:{
                    deptId:"",
                    flowDesignId:"",
                    name:"", 
                    checkerType:"",
                    checkerValue:[],
                    checkerValueLabel:"",
                    orderNum:"",
                },
                rules: {
                    orderNum: [
                        { required: true, message: '请输入步骤编号', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入步骤名称', trigger: 'blur' }
                    ],
                    checkerType: [
                        { required: true, message: '请选择审批人依据类型', trigger: 'blur' }
                    ]
                },
                checkerTypes:[{
                    value: 1,
                    label: '指定人员'
                }]
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(flowDesignId,deptId){
                this.form.deptId=deptId;
                this.form.flowDesignId=flowDesignId;
                this.form.checkerValue=[];
                this.form.checkerValueLabel="",
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        //验证指定人员不能为空
                        if(this.form.checkerType == 1){
                            if(this.form.checkerValue.length == 0){
                                this.$commonFn.showTip('审核人依据值不可为空',3);
                                return;
                            }
                        }

                        let url= this.flowProcedureAddUrl;
                        let data = {
                            deptId:this.form.deptId,
                            flowDesignId:this.form.flowDesignId,
                            name:this.form.name,
                            checkerType:this.form.checkerType,
                            checkerValue:this.form.checkerValue.join(),
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getProcedureData(this.form.flowDesignId);
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => { 
                    this.$refs['userTransfer'].init(2,this.form.checkerValue,2,this.form.deptId);
                })
            },
            setUser(key,label){
                this.form.checkerValue = key;
                this.form.checkerValueLabel = label.join(";");
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/flow/design/AddProcedure.vue